import { useEffect } from 'react';

export default function useBillingCheckoutNotice(setBillingNotice) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const billingResult = (params.get('billing') || '').trim().toLowerCase();
    if (!billingResult) return;

    if (billingResult === 'success') {
      setBillingNotice('Checkout erfolgreich abgeschlossen. Billing-Daten werden jetzt synchronisiert.');
    } else if (billingResult === 'cancel') {
      setBillingNotice('Checkout wurde abgebrochen. Es wurde keine Zahlung ausgelöst.');
    }

    params.delete('billing');
    const nextSearch = params.toString();
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;
    window.history.replaceState({}, '', nextUrl);
  }, [setBillingNotice]);
}
